<li class="learning-list-li">
    <div class="list-box">
        <div class="flip-container" id="{{LearningCard['CourseID']+'-'+LearningCard['ILTID']}}">
            <div class="flip-container">
                <div class="flipper">
                    <div class="front">
                        <div class="front-inner"
                            [ngSwitch]="LearningCard['CourseImage'].substring(LearningCard['CourseImage'].lastIndexOf('/')+1, LearningCard['CourseImage'].length)">
                            <!-- (click)="flip(LearningCard['CourseID']+'-'+LearningCard['ILTID'])" -->
<li class="learning-list-li">
    <figure class="course">
        <img *ngSwitchCase="'ILT.jpg'" class="responsiveImage" src="assets/img/ILT.jpg" alt="Image">
        <img *ngSwitchCase="'ebook.jpg'" class="responsiveImage" src="assets/img/ebook.jpg" alt="Image">
        <img *ngSwitchCase="'Elearning.jpg'" class="responsiveImage" src="assets/img/Elearning.jpg" alt="Image">
        <img *ngSwitchDefault class="responsiveImage" src="{{LearningCard['CourseImage']}}" alt="Image">
        <div *ngIf="!bs.isReadAndSign">
            <a href="javascript:void(0);" class="star-label" (click)="showReviewPanel(LearningCard,CardType)">
                <span class="fa fa-star"></span>{{LearningCard['CourseRating']}}
            </a>
        </div>
        <div *ngIf="LearningCard['GamificationPoints']>0 && !bs.isReadAndSign">
            <a href="javascript:void(0);" class="winstar-label ui-link"
                (click)="showGamificationRule(ItemDetail['CourseID'])">
                <span class="star-icon"></span>{{LearningCard['GamificationUserAchievedPoints']}} /
                {{LearningCard['GamificationPoints']}}
            </a>
        </div>
        <div class="progress-bar-main">
            <div class="progress-bar-inn" [style.width]="LearningCard['Progress']+'%'"></div>
        </div>
        <div class="stats-container">
            <div class="course_name" [innerHTML]="LearningCard['CourseName']"></div>
            <span>{{LearningCard['CourseTypeName']}}</span>
            <span *ngIf="!isPlay "
                [ngClass]="{'opted-type':LearningCard['LearningFlag']=='Opted','assigned-type':LearningCard['LearningFlag']=='Assigned'}">{{LearningCard['LearningFlag']}}</span>
        </div>

        <div class="hover">
            <div class="title-content hand-cursor" (click)="openLearningDetail(LearningCard,false,CardType)">
                <span [innerHtml]="bs.textLimit(LearningCard['CourseName'],22)"></span>
                <span class="tooltip-text" style="word-break: break-word;" *ngIf="LearningCard['CourseName'].length>22" [innerHtml]="LearningCard['CourseName']"></span>
                    <div *ngIf="LearningCard['Topic'] !=null && LearningCard['Topic']!=undefined">
                        <span [innerHtml]="bs.textLimit(LearningCard['Topic'],22)"></span>
                        <span class="tooltip-text" style="word-break: break-word;" *ngIf="LearningCard['Topic'].length>22" [innerHtml]="LearningCard['Topic']"></span>
                    </div>
            </div>
            <div class="info">
                <div class="one-third b-right hand-cursor" *ngIf="!bs.isReadAndSign"
                    (click)="openLearningDetail(LearningCard,false,CardType)">
                    <div class="stat"><span>{{bs.getResource('rbkey_CrdtHrsLBL')}}</span>
                        {{LearningCard['CreditHours']}}</div>
                </div>
                <div class="one-third hand-cursor" *ngIf="!bs.isReadAndSign"
                    (click)="openLearningDetail(LearningCard,false,CardType)">
                    <div class="stat"><span>{{bs.getResource('rbkey_ExpryDtLBL_App')}}</span> {{LearningCard['ExpiryDay']}}
                        {{LearningCard['ExpiryYear']}}</div>
                </div>
                <div class="one-third b-right hand-cursor" *ngIf="bs.isReadAndSign"
                    (click)="openLearningDetail(LearningCard,false,CardType)">
                    <div class="stat"><span>{{bs.getResource('rbkey_StrtDtLBL')}}</span>
                        {{LearningCard['StartDay']}}
                        {{LearningCard['StartYear']}}</div>
                </div>
                <div class="one-third hand-cursor" *ngIf="bs.isReadAndSign"
                    (click)="openLearningDetail(LearningCard,false,CardType)">
                    <div class="stat"><span>{{bs.getResource('rbkey_EndDtLBL')}}</span> {{LearningCard['ExpiryDay']}}
                        {{LearningCard['ExpiryYear']}}</div>
                </div>
                <div class="play action-icon tooltips hand-cursor" style="z-index:9999;"
                    (click)="openLearningDetail(LearningCard,true,CardType)"
                    *ngIf="LearningCard['ChildNodeAction']=='R' && !isPlay">
                    <i class="fa"></i>
                    <span class="tooltiptext">Resume</span>
                </div>
                <div class="progress-status hand-cursor" style="z-index:99;"
                    (click)="openLearningDetail(LearningCard,false,CardType)">
                    {{LearningCard['Status'] +' | '+ LearningCard['Progress'] +'%' }}
                </div>
            </div>

            <div class="icons">
                <div class="select action-icon tooltips hand-cursor"
                    (click)="openLearningDetail(LearningCard,false,CardType)" *ngIf="isPlay">
                    <i class="fa"></i>
                    <span class="tooltiptext">Detail</span>
                </div>

                <div class="select action-icon tooltips hand-cursor"
                    (click)="openLearningDetail(LearningCard,false,CardType)"
                    *ngIf="(LearningCard['ChildNodeAction']=='P' || LearningCard['ChildNodeAction']=='L')  && !isPlay ">
                    <i class="fa"></i>
                    <span class="tooltiptext">Detail</span>
                </div>


                <div class="select action-icon tooltips hand-cursor"
                    (click)="openLearningDetail(LearningCard,false,CardType)"
                    *ngIf="LearningCard['ChildNodeAction']=='R' && !isPlay">
                    <i class="fa"></i>
                    <span class="tooltiptext">Detail</span>
                </div>

                <div *ngIf="LearningCard['CourseType']!='T' && !isPlay && !bs.isReadAndSign && enableActiveWall"
                    class="share action-icon tooltips hand-cursor" (click)="openPanel()"> <i class="fa"></i> <span
                        class="tooltiptext">Share</span></div>
                        

                <div *ngIf="LearningCard['CourseType']!='T' && LearningCard['CourseType']!='E' && !isPlay && !bs.isReadAndSign"
                    class="report action-icon tooltips hand-cursor" (click)="generateActivityReport(LearningCard)"> <i
                        class="fa"></i> <span class="tooltiptext"> {{bs.getResource('rbkey_ActvtyRprtLBL_App')}}</span>
                </div>

            </div>
        </div>
        <a href="#"></a>
    </figure>

</li>



</div>
</div>

</div>
</div>
</div>
</div>
<div id="divGamificationRuleforCard{{ItemDetail['CourseID']}}" class="hideDiv">
    <app-gamification-rule *ngIf="loadGamificationRule(ItemDetail['CourseID'])" [learningItem]="ItemDetail">
    </app-gamification-rule>
</div>
<div
    *ngIf="LearningCard['MyUserProfiles']!=[] && LearningCard['MyUserProfiles']!=null && LearningCard['MyUserProfiles']!=undefined">
    <div class="footer" *ngIf="LearningCard['MyUserProfiles'].length>0">
        <div class="box-left">
            <!-- <a class="box-users-likes" href="javascript:void(0);">Linked to your interest in {{LearningCard['MyUserProfiles'][0]['AttributeName']}}</a> -->
            <a class="box-profile-likes" href="javascript:void(0);">Linked to your interest in
                {{LearningCard['MyUserProfiles'][0]['AttributeName']}}</a>


        </div>
    </div>

    <div id="pre-requisite{{LearningCard['CourseID']}}" class="leaderboard-tooltip animated fadeIn">
        <div class="leaderboard-tooltip-inner">
            <a href="javascript:void(0);" class="leaderboard-close-icon"><img class="hand-cursor"
                    (click)="ClosePeersPanel(LearningCard['CourseID'],$event)" src="assets/img/cross-icon-white.png"
                    alt="Icon"></a>
            <div class="leaderboard-tooltip-top">
                LEARNING HISTORY
            </div>
            <div class="leaderboard-tooltip-bottom">
                <table>
                    <tbody>
                        <tr>
                            <th>AttributeName</th>
                            <!-- <th>Job Profile</th> -->
                        </tr>
                        <tr *ngFor="let currentProfile of LearningCard['MyUserProfiles'];">
                            <td>{{currentProfile.AttributeName}}</td>
                            <!-- <td>{{currentPeer.JobRole}}</td> -->
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<!-- <div *ngIf="LearningCard['MyPeers']!='' && LearningCard['MyPeers']!=null && LearningCard['MyPeers']!=undefined">
  <div class="footer" *ngIf="LearningCard['MyPeers'].length>0" >
          <div class="box-left">
              <a class="box-users-likes" (click)="ShowPeersPanel(LearningCard['CourseID'],$event)" href="javascript:void(0);">{{LearningCard['MyPeers'][0]['UserName']}} and {{LearningCard['MyPeers'].length-1}} more of your peers have taken this course</a>
          </div>
  </div>
</div> -->

<div *ngIf="LearningCard['MyPeers']!=[] && LearningCard['MyPeers']!=null && LearningCard['MyPeers']!=undefined">
    <div class="footer" *ngIf="LearningCard['MyPeers'].length>0">
        <div class="box-left">
            <a class="box-users-likes hand-cursor" *ngIf="(LearningCard['MyPeers'].length>1) else peersTemplate;"
                (click)="ShowPeersPanel(LearningCard['CourseID'],$event)" data-toggle="modal" data-target="#suggestions"
                href="javascript:void(0);">{{LearningCard['MyPeers'][0]['UserName']}} and
                {{LearningCard['MyPeers'].length-1}} more of your peers have taken this course</a>
            <ng-template #peersTemplate>
                <a class="box-users-likes hand-cursor" (click)="ShowPeersPanel(LearningCard['CourseID'],$event)"
                    href="javascript:void(0);">{{LearningCard['MyPeers'][0]['UserName']}} of your peers have taken this
                    course</a>
            </ng-template>
        </div>
    </div>
    <!---->
    <!-- <div class="pre-requisute">
  <div id="pre-requisite{{LearningCard['CourseID']}}" class="pre-requisute-tooltip animated fadeIn">
      <div class="pre-requisute-tooltip-inner">
          <a href="javascript:void(0);" class="pre-requisute-close-icon">
              <img src="assets/img/cross-icon-white.png" (click)="ClosePeersPanel(LearningCard['CourseID'])" alt="{{bs.getResource('rbkey_Ctlgtr1ImgLBL')}}">
          </a>
          <div class="pre-requisute-tooltip-top">
              PEERS
          </div>
          <div >
              <div class="pre-requisute-tooltip-bottom">
                  <table class="pre-requisute-table">
                      <thead>
                          <tr>
                              <th>S.No.</th>
                              <th>PEER</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr *ngFor="let currentPeer of LearningCard['MyPeers'];let i =index;" >
                              <td>{{i+1}}</td>
                              <td>{{currentPeer.UserName}}</td>
                          </tr>
                      </tbody>
                  </table>
              </div>
          </div>
         
      </div>
  </div>
</div> -->
    <!---->
    <!---->

    <div id="pre-requisite{{LearningCard['CourseID']}}" class="leaderboard-tooltip animated fadeIn">
        <div class="leaderboard-tooltip-inner">
            <a href="javascript:void(0);" class="leaderboard-close-icon"><img class="hand-cursor"
                    (click)="ClosePeersPanel(LearningCard['CourseID'],$event)" src="assets/img/cross-icon-white.png"
                    alt="Icon"></a>
            <div class="leaderboard-tooltip-top">
                PEERS
            </div>
            <div class="leaderboard-tooltip-bottom">
                <table>
                    <tbody>
                        <tr>
                            <th>PROFILE IMAGE</th>
                            <th>USER</th>
                            <th>Job Profile</th>
                        </tr>
                        <tr *ngFor="let currentPeer of LearningCard['MyPeers'];">
                            <td><img _ngcontent-c5="" class="img-thumbnail img-circle" height="30"
                                    style="font-size:3px;" width="30" src="{{currentPeer.ImagePath}}"
                                    alt="Profile Image" title="{{currentPeer.UserName}}"></td>
                            <td>{{currentPeer.UserName}}</td>
                            <td>{{currentPeer.JobRole}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <!---->
</div>

<div
    *ngIf="LearningCard['MappedSkills']!=[] && LearningCard['MappedSkills']!=null && LearningCard['MappedSkills']!=undefined">
    <div class="footer" *ngIf="LearningCard['MappedSkills'].length>0">
        <div class="box-left">
            <a class="box-users-likes hand-cursor" *ngIf="(LearningCard['MappedSkills'].length>1) else skillsTemplate;"
                (click)="ShowPeersPanel(LearningCard['CourseID'],$event)" href="javascript:void(0);" data-toggle="modal"
                data-target="#suggestions">Improve
                {{LearningCard['MappedSkills'][0]['SkillName']}} and {{LearningCard['MappedSkills'].length-1}} more
                skills</a>
            <!-- <a  class="view-all-topic-label" href="javascript:void(0);" style="top: 35px;" data-toggle="modal" data-target="#suggestions">VIEW ALL TOPICS</a> -->
            <ng-template #skillsTemplate>
                <a class="box-users-likes hand-cursor" (click)="ShowPeersPanel(LearningCard['CourseID'],$event)"
                    href="javascript:void(0);" data-toggle="modal" data-target="#suggestions">Improve
                    {{LearningCard['MappedSkills'][0]['SkillName']}} skills</a>
            </ng-template>
        </div>
    </div>

    <div id="pre-requisite{{LearningCard['CourseID']}}" class="leaderboard-tooltip animated fadeIn">
        <div class="leaderboard-tooltip-inner">
            <a href="javascript:void(0);" class="leaderboard-close-icon"><img class="hand-cursor"
                    (click)="ClosePeersPanel(LearningCard['CourseID'],$event)" src="assets/img/cross-icon-white.png"
                    alt="Icon"></a>
            <div class="leaderboard-tooltip-top">
                SKILLS
            </div>
            <div class="leaderboard-tooltip-bottom">
                <table>
                    <tbody>
                        <tr>
                            <th>Skill Name</th>
                            <th>Skill Category</th>
                            <th>Skill Level</th>
                            <!-- <th>Job Profile</th> -->
                        </tr>
                        <tr *ngFor="let currentSkill of LearningCard['MappedSkills'];">
                            <td>{{currentSkill.SkillName}}</td>
                            <td>{{currentSkill.SkillCategory}}</td>
                            <td>{{currentSkill.SkillLevel}}</td>
                            <!-- <td>{{currentPeer.JobRole}}</td> -->
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <!-- 
   <div id="pre-requisite{{LearningCard['CourseID']}}" placement="bottom" class="leaderboard-tooltip animated fadeIn">
      <div class="leaderboard-tooltip-inner">
          <a href="javascript:void(0);" class="leaderboard-close-icon"><img
                  (click)="ClosePeersPanel(LearningCard['CourseID'],$event)" src="assets/img/cross-icon-white.png"
                  alt="Icon"></a>
          <div class="leaderboard-tooltip-top">
              SKILLS
          </div>
          <div class="leaderboard-tooltip-bottom">
              <table>
                  <tbody>
                      <tr>
                          <th>Skill Name</th> -->
    <!-- <th>Job Profile</th> -->
    <!-- </tr>
                      <tr *ngFor="let currentSkill of LearningCard['MappedSkills'];">
                          <td>{{currentSkill.SkillName}}</td> -->
    <!-- <td>{{currentPeer.JobRole}}</td> -->
    <!-- </tr>
                  </tbody>
              </table>
          </div>
      </div>
  </div>  -->
    <!-- <div>
      {{myDiv}}
  </div> -->


</div>

<div
    *ngIf="LearningCard['AvgKpiImprovement']!='' && LearningCard['AvgKpiImprovement']!=null && LearningCard['AvgKpiImprovement']!=undefined">
    <div class="footer" *ngIf="LearningCard['AvgKpiImprovement'].length>0">
        <div class="box-left">
            <a class="box-users-likes" href="javascript:void(0);">Avg. improvement of
                {{LearningCard['AvgKpiImprovement'][0]['AvgImprovement']}} % for
                {{LearningCard['AvgKpiImprovement'][0]['UserCount']}} users</a>
        </div>
    </div>
</div>

<div
    *ngIf="LearningCard['Coursekeywords']!=[] && LearningCard['Coursekeywords']!=null && LearningCard['Coursekeywords']!=undefined">
    <div class="footer" *ngIf="LearningCard['Coursekeywords'].length>0">
        <div class="box-left">
            <a class="box-users-likes hand-cursor" *ngIf="(LearningCard['Coursekeywords'].length>1) else peersTemplate;"
                (click)="ShowPeersPanel(LearningCard['CourseID'],$event)" href="javascript:void(0);" data-toggle="modal"
                data-target="#suggestions">{{LearningCard['Coursekeywords'][0]}} and
                {{LearningCard['Coursekeywords'].length-1}} more Keywords</a>
            <ng-template #peersTemplate>
                <a class="box-users-likes hand-cursor" (click)="ShowPeersPanel(LearningCard['CourseID'],$event)"
                    href="javascript:void(0);" data-toggle="modal"
                    data-target="#suggestions">{{LearningCard['Coursekeywords'][0]}} keyword</a>
            </ng-template>
        </div>
    </div>

    <div id="pre-requisite{{LearningCard['CourseID']}}" class="leaderboard-tooltip animated fadeIn">
        <div class="leaderboard-tooltip-inner">
            <a href="javascript:void(0);" class="leaderboard-close-icon"><img class="hand-cursor"
                    (click)="ClosePeersPanel(LearningCard['CourseID'],$event)" src="assets/img/cross-icon-white.png"
                    alt="Icon"></a>
            <div class="leaderboard-tooltip-top interest-keys">
                COURSE KEYWORDS
            </div>
            <div class="leaderboard-tooltip-bottom">
                <table>
                    <tbody>
                        <tr>
                            <th>Keywords</th>
                            <!-- <th>Job Profile</th> -->
                        </tr>
                        <tr *ngFor="let currentKeyword of LearningCard['Coursekeywords'];" class="chips">
                            <td>{{currentKeyword}}</td>
                            <!-- <td>{{currentPeer.JobRole}}</td> -->
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

</li>